import React from 'react';
import { motion } from 'framer-motion';
import { Elevation } from '../../types';
interface ElevationStripProps {
  elevations: Elevation[];
  selectedElevationId?: string;
  onSelect: (elevation: Elevation) => void;
  compact?: boolean;
}
export function ElevationStrip({
  elevations,
  selectedElevationId,
  onSelect,
  compact = false
}: ElevationStripProps) {
  return <div className={`flex gap-2 ${compact ? 'mt-2' : 'mt-4'}`} data-id="element-1135">
      {elevations.map(elevation => {
      const isSelected = selectedElevationId === elevation.id;
      return <motion.button key={elevation.id} onClick={e => {
        e.stopPropagation();
        onSelect(elevation);
      }} className={`
              relative group overflow-hidden rounded-md border transition-all duration-200
              ${compact ? 'w-10 h-10' : 'w-16 h-12'}
              ${isSelected ? 'border-cyan-400 ring-2 ring-cyan-400/30' : 'border-white/20 hover:border-white/60'}
            `} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-1136">
            <img src={elevation.thumbnailUrl} alt={elevation.name} className="w-full h-full object-cover" data-id="element-1137" />

            {/* Letter Badge */}
            <div className={`
              absolute bottom-0 right-0 px-1 text-[10px] font-bold leading-none
              ${isSelected ? 'bg-cyan-500 text-white' : 'bg-slate-900/80 text-white'}
            `} data-id="element-1138">
              {elevation.letter}
            </div>

            {/* Tooltip on Hover */}
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center" data-id="element-1139">
              <span className="text-[8px] text-white font-medium uppercase tracking-wider" data-id="element-1140">
                {elevation.name}
              </span>
            </div>
          </motion.button>;
    })}
    </div>;
}